export enum MerchantUserSuspendTypeEnum {
    RemainderOfDay = 1,
    UntilReactivated = 2,
    For7Days = 3,
    For30Days = 4,
    For1Day = 5,
    For3Days = 6
}
